import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row, Table } from 'react-bootstrap';
import { CommonAxiosGet, CommonAxiosPut } from '../../CommonUtils/CommonAxios';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import * as Yup from "yup";
import { config } from '../../CommonUtils/CommonURLS';
import Swal from 'sweetalert2';
export default function InspBoardOfGoverners() {
    const [governerPersonalData, setGovernerPersonalData] = useState([]);
    const [loading, setLoading] = useState(true);
    const validationSchema = Yup.object({
        governer: Yup.array().of(
            Yup.object({
                recommendedStatus: Yup.string().required("Recommended is required"),
                // remarks: Yup.string().required("Remarks is required")
            })
        )
    });

    const formik = useFormik({
        initialValues: { governer: [] },
        enableReinitialize: true,
        validationSchema,
        onSubmit: (values) => submitGovernerDetails(values)
    });
    function getInspectionGovernerDetails() {
        let url = config.url.FAC_URL + "getSocietyNameChange";
        CommonAxiosGet(url)
            .then((res) => {
                if (res && res.data.status === true) {
                    const data = res?.data?.boardOfGoverners || [];
                    setGovernerPersonalData(res?.data?.boardOfGoverners || []);
                    formik.setValues({
                        governer: data?.map(cp => ({
                            sno: cp.sno,
                            recommendedStatus: cp.recommended_status ? cp.recommended_status : "",
                            remarks: cp.remarks || ""
                        })
                        )
                    })
                } else {
                    setGovernerPersonalData([]);
                    formik.setValues({ governer: [] });
                }
            })
            .catch((e) => {
                console.error(e);
                setGovernerPersonalData([]);
                formik.setValues({ governer: [] });
               
            });
    }
    function submitGovernerDetails(values) {
        if (!values.governer || values.governer.length === 0) {
            failureAlert("No data to submit!");
            return;
        }
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to submit all recommendations?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Submit",
            cancelButtonText: "Cancel"
        }).then((result) => {
            if (result.isConfirmed) {
                let url = config.url.FAC_URL + "updateBoardOfGoverners";
                CommonAxiosPut(url, values.governer)
                    .then((res) => {
                        if (res && res.data.status === true) {
                            successAlert2(res?.data?.sdesc);
                            getInspectionGovernerDetails();
                        } else {
                            failureAlert(res?.data?.sdesc || "Submission Failed");
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                        failureAlert("Something went wrong!");
                    });
            }
        });
    }
    useEffect(() => {
        getInspectionGovernerDetails();
    }, []);
    const isAlreadySubmitted = governerPersonalData.every(
        item => item.recommended_status !== null && item.recommended_status !== ""
    );
    return (
        <>

            <Container fluid className="py-3">
                <FormikProvider value={formik}>
                    <Form onSubmit={formik.handleSubmit}>
                        {governerPersonalData.length > 0 ? (
                            <div className="mb-4">
                                {/* <h6 className="text-success mb-2"><b>Board of Governors Details</b></h6>
                             */}
                                <h5 className="mb-3 innerheader-new">
                                    <span>Board of Governors Details</span>
                                </h5>
                                <Table bordered responsive>
                                    <thead className="table-primary">
                                        <tr>
                                            <th>S.No</th>
                                            <th>Name</th>
                                            <th>Role</th>
                                            <th>Contact</th>
                                            <th>Address</th>
                                            <th>Responsibilities</th>
                                            <th>Recommended</th>
                                            <th>Remarks</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {governerPersonalData.map((cp, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{cp.name_of_chairperson}</td>
                                                <td>{cp.role}</td>
                                                <td>{cp.contact}</td>
                                                <td>{cp.address}</td>
                                                <td>{cp.responsibilities}</td>

                                                <td className="text-center">
                                                    <div className="d-flex justify-content-center gap-3">
                                                        <label>
                                                            <Field
                                                                type="radio"
                                                                name={`governer.${index}.recommendedStatus`}
                                                                value="YES"
                                                                disabled={cp.recommended_status !== null && cp.recommended_status !== ""}
                                                            />&nbsp; Yes
                                                        </label>

                                                        <label>
                                                            <Field
                                                                type="radio"
                                                                name={`governer.${index}.recommendedStatus`}
                                                                value="NO"
                                                                disabled={cp.recommended_status !== null && cp.recommended_status !== ""}
                                                            /> &nbsp;No
                                                        </label>
                                                    </div>
                                                    <ErrorMessage
                                                        name={`governer.${index}.recommendedStatus`}
                                                        component="div"
                                                        className="text-danger small"
                                                    />
                                                </td>
                                                <td>
                                                    <Field
                                                        type="text"
                                                        name={`governer[${index}].remarks`}
                                                        className="form-control"
                                                        placeholder="Enter remarks"
                                                        disabled={cp.recommended_status !== null && cp.recommended_status !== ""}
                                                    />
                                                    <ErrorMessage
                                                        name={`governer[${index}].remarks`}
                                                        component="div"
                                                        className="text-danger"
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        ) : (
                            // <div className="text-center mt-4">
                            //     <h6 className="text-danger">********No Board of Governors Data Found**********</h6>
                            // </div>
                            <center className="text-danger mt-4 h5">
                                {" "}
                                ***** No Data Found *****{" "}
                            </center>
                        )}
                        {governerPersonalData.length > 0 && (
                            <Row className="mt-4">
                                <Col xs={12} className="text-end">
                                    {!isAlreadySubmitted ? (
                                        <button type="submit" className="btn btn-primary">
                                            Submit
                                        </button>
                                    ) : (
                                        <span className="text-success fw-bold">
                                            Already Submitted
                                        </span>
                                    )}
                                </Col>
                            </Row>
                        )}
                    </Form>
                </FormikProvider>
            </Container>
        </>
    );
}